/** Superficie pública de shared/ui. */
export {
  appToastConfig,
  showSuccess,
  showSuccessAfterModalClose,
  showError,
  showErrorAfterModalClose,
  showInfo,
  InlineAppToast,
  toastTopOffset,
} from './appToast';
export type { AppToastTone, ShowErrorReportOptions } from './appToast';
export { BarcodeScannerModal } from './BarcodeScannerModal';
export { CatalogPagination } from './CatalogPagination';
export type { CatalogPaginationPlacement, CatalogPageSizePickerConfig, OperationalPageSizePickerConfig } from './CatalogPagination';
export { MobilePagination } from './MobilePagination';
export { ChipWrapRow } from './ChipWrapRow';
export { useOperationalWebSearchFocus } from './hooks-screen/useOperationalWebSearchFocus';
export { useScreenLoad, useScreenLoadShell } from './hooks-screen/useScreenLoad';
export { useScreenRefresh } from './hooks-screen/useScreenRefresh';
export { useDebouncedValue } from './hooks-ui/useDebouncedValue';
export { useModalBackdropPadding } from './hooks-ui/useModalBackdropPadding';
export { InventoryIsoDateField } from './InventoryIsoDateField';
export type { InventoryIsoDateFieldProps } from './InventoryIsoDateField';
export { HmTimeField } from './HmTimeField';
export { iosDatePickerDisplay } from './iosDatePickerDisplay';
export { ModuleEmptyState } from './ModuleEmptyState';
export type { ModuleEmptyStateProps } from './ModuleEmptyState';
export { NumericTextInput } from './NumericTextInput';
export type { NumericTextInputProps } from './NumericTextInput';
export { OperationalHintIcon } from './OperationalHintIcon';
export type { OperationalHintSeverity } from './OperationalHintIcon';
export { OperationalListSectionHeader } from './OperationalListSectionHeader';
export { scrollPaginatedListToTop } from './paginatedListScroll';
export type { PaginatedListScrollRefs } from './paginatedListScroll';
export { hapticAddToCart } from './posHaptics';
export { posSharedUi } from './posSharedUi';
export { ProminentSearchWithScanner } from './ProminentSearchWithScanner';
export type { SearchScanTone, ProminentSearchWithScannerProps } from './ProminentSearchWithScanner';
export { SCREEN_REFRESH_COPY, resolveScreenRefreshOnline, presentScreenRefreshFeedback, runScreenRefresh } from './screenRefreshFeedback';
export type { ScreenRefreshResult, RunScreenRefreshOptions } from './screenRefreshFeedback';
export { useOperationalConfirm } from './useOperationalConfirm';
export type { OperationalConfirmOptions } from './useOperationalConfirm';
export { VIRTUALIZED_LIST_PROPS } from './virtualizedListProps';
export { WEB_BUTTON_FOCUS_RESET } from './webButtonFocusReset';
export { SoftPressable } from './SoftPressable';
export { UnderlineTabBar } from './UnderlineTabBar';
export type { UnderlineTabOption } from './UnderlineTabBar';
export { WebExpiryDateInput } from './WebExpiryDateInput';
export { WebTimeInput } from './WebTimeInput';
export {
  webNativeTemporalInputStyle,
  nativeTemporalTriggerStyle,
  NATIVE_TEMPORAL_RADIUS,
  NATIVE_TEMPORAL_MIN_HEIGHT,
  NATIVE_TEMPORAL_COMFORTABLE_HEIGHT,
} from './webNativeTemporalInput';
export type { WebNativeTemporalSize } from './webNativeTemporalInput';
